import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import ToggleArrow from '@swf/core/assets/icons/arrow.svg';
import { CheckmarkIcon } from '@swf/poker';

import type { TableSortRule } from '../../../../types/MTT';

import SortByDropdown from './SortByDropdown/SortByDropdown';
import { TXTCLI_Filters, TXTCLI_Sort_by } from './SortFilterContainer.messages.json';
import styles from './SortFilterContainer.scss';

interface SortFilterContainerProps {
  hasFilters: boolean;
  isSortByOpened: boolean;
  onCloseSortBy: () => void;
  onFiltersClick: () => void;
  onOptionSelect: (payload: { id: string; desc: boolean }) => void;
  onSortByClick: () => void;
  sortRule: TableSortRule;
}

const SortFilterContainer: React.FC<SortFilterContainerProps> = ({
  hasFilters,
  isSortByOpened,
  onCloseSortBy,
  onFiltersClick,
  onOptionSelect,
  onSortByClick,
  sortRule
}) => (
  <div className={styles.sortFilterContainer}>
    <div className={classNames(styles.section, styles.sortBy)} onClick={onSortByClick}>
      <Translation {...TXTCLI_Sort_by} />
      <ToggleArrow
        className={classNames(styles.arrow, { [styles.upwardsArrow]: isSortByOpened })}
      />
    </div>
    <SortByDropdown
      show={isSortByOpened}
      onOptionSelect={onOptionSelect}
      onClose={onCloseSortBy}
      sortRule={sortRule}
    />
    <div
      className={classNames(styles.section, {
        [styles.checked]: hasFilters
      })}
      onClick={onFiltersClick}
    >
      <Translation {...TXTCLI_Filters} />
      {hasFilters && <CheckmarkIcon className={styles.icon} />}
    </div>
  </div>
);

export default SortFilterContainer;
